import type { OptionFetcher, PaginationInfo } from '@eo/shared';

import getApiHttpClient from '../../../httpClients/getApiHttpClient';
import type { ClientCapacity, CreateSupplementBody, StaffOption } from './types';

export async function fetchClientCapacity(id: string, month: string): Promise<ClientCapacity> {
  const res = await getApiHttpClient().get<ClientCapacity>(`/api/v1/cfo/clients/${id}/capacity`, {
    params: { month },
  });
  return res.data;
}

export const searchMembers: OptionFetcher = async ({ search, page }) => {
  const res = await getApiHttpClient().get<{ users: StaffOption[]; pagination: PaginationInfo }>(
    '/api/v1/cfo/users',
    { params: { active: true, ...(search && { search }), page } },
  );
  return { items: res.data.users, pagination: res.data.pagination };
};

export async function upsertBudget(body: {
  clientId: string;
  effectiveMonth: string;
  fixedHours: number;
  variableHours: number;
}): Promise<void> {
  await getApiHttpClient().put('/api/v1/cfo/capacity/budgets', body);
}

export async function createSupplement(body: CreateSupplementBody): Promise<void> {
  await getApiHttpClient().post('/api/v1/cfo/capacity/supplements', body);
}

export async function removeSupplement(id: string): Promise<void> {
  await getApiHttpClient().delete(`/api/v1/cfo/capacity/supplements/${id}`);
}

export async function upsertAssignment(body: {
  clientId: string;
  userId: string;
  fixedHours: number;
  variableHours: number;
}): Promise<void> {
  await getApiHttpClient().put('/api/v1/cfo/capacity/assignments', body);
}

export async function removeAssignment(id: string): Promise<void> {
  await getApiHttpClient().delete(`/api/v1/cfo/capacity/assignments/${id}`);
}
